/**
 * Environment configuration utility
 * This file exports the environment configuration from the environments directory
 */

import envConfig from './environments';

export const env = envConfig;
